import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";

function FilterDMDVT({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    ten_dvt: "",
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.ten_dvt) {
      condition.ten_dvt = {
        $regex: filter.ten_dvt?.split(" ").join(".*"),
        $options: "i",
      };
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        label="Tên đơn vị tính"
        placeholder="Tìm theo tên đơn vị tính"
        value={filter.ten_dvt}
        onSearch={(val) => setFilter({ ...filter, ten_dvt: val })}
      />
    </WrapperFilter>
  );
}

export default FilterDMDVT;
